/**
 * PremiumAgentCarouselListings
 * 
 * @Author: Focci
 * @Date: 2024-10-25 14:40:53
 * @Last Modified by: Focci
 * @Last Modified time: 2024-10-25 14:40:53
 */

'use client'

import AspectRatioCover from '@comp/AspectRatioCover'
import Link from 'next/link'
import Carousel from '@comp/swiper/Carousel'
import { propertyDetail } from '@lib/route/house'
import { useLocale } from 'next-intl'
import { propertyType } from '@lib/config'
import { imageSize } from '@lib/image/loader'
import { useMemo } from 'react'
import PropertyIcons from '../../property/PropertyIcons'
import PropertyChips from '../../property/Chips'
import PropertySoldDateLabel from '../../property/PropertySoldDateLabel'
import { getPremiumListings } from './_'

export function PremiumAgentListing({ data }) {
  const locale = useLocale()
  const isHouse = data.typeId === propertyType.RESIDENTIAL
  
  return (
    <Link 
      className="inline-block bg-white rounded-md overflow-hidden w-full"
      href={propertyDetail(data.slug, locale)}
    >
      <div className="relative">
        <AspectRatioCover
          unoptimized
          src={imageSize(data?.images?.[0] || '', 480, 360)}
          width={480}
          height={360}
          alt={data.address || ''}
        />
        <div className="absolute top-2 left-2">
          <PropertyChips onSale={isHouse} sold={!isHouse} />
        </div>
      </div>
      <div className="flex flex-col gap-1 p-2">
        {isHouse && data.listAtLabel && (<span className="text-error font-medium text-f.6">{data.listAtLabel}</span>)}
        {!isHouse && data?.soldData && (
          <PropertySoldDateLabel
            soldData={data.soldData}
            className="text-error font-medium text-f.6"
          />
        )}
        <div className="text-f.8 font-bold">{data.priceLabel}</div>
        <PropertyIcons data={data.propertyIcon} />
        <div className="line-clamp-1">{data.address}</div>
      </div>
    </Link>
  )
}

export default function PremiumAgentCarouselListings({ house }) {
  const { properties: listings, sold_properties: solds, } = house || {}
  const data = useMemo(() => getPremiumListings(listings, solds), [listings, solds])
  
  return (
    <div className="p-4 bg-cf0">
      <Carousel 
        showNavigation={false}
        slidesPerView="auto"
        slideClassName="!w-4/5"
        paginationWrapperClassName="-bottom-2"
        spaceBetween={15}
        breakpoints={{}}
        data={data}
        SlideRender={PremiumAgentListing}
      />
    </div>
  )
}

// PremiumAgentCarouselListings.propTypes = {
//   className: PropTypes.string,
// }
